import { useState } from 'react';
import { useMediaQuery, type Theme } from '@mui/material';
import { AmplitudeEvent, trackAmplitudeEvent, SeoFeatureInteracted } from '@/lib/analyticsHelper';
import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_caregiver as Caregiver } from '@/__generated__/getSearchResults';
import ReadMore from '../../ReadMore';

interface CaregiverBioProps {
  caregiver: Caregiver;
}

const CaregiverBio = ({ caregiver }: CaregiverBioProps) => {
  const isMobileOrSmaller = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  const caregiverProfile = caregiver.profiles?.commonCaregiverProfile;
  const [isExpanded, setIsExpanded] = useState(false);

  const amplitudeTrackingForShowMoreBio = () => {
    const amplitudeData: SeoFeatureInteracted = {
      feature_name: 'Show More Bio',
    };

    trackAmplitudeEvent(AmplitudeEvent.seoFeatureInteracted, amplitudeData);
  };

  const handleShowMoreBio = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const target = e.target as HTMLAnchorElement;
    if (target.tagName.toLowerCase() === 'button') {
      setIsExpanded(!isExpanded);
      if (!isExpanded) {
        amplitudeTrackingForShowMoreBio();
      }
    }
  };

  return (
    <ReadMore
      gutterBottom
      color="textPrimary"
      component="div"
      variant="body2"
      charLimit={isMobileOrSmaller ? 210 : 330}
      value={caregiverProfile?.bio.experienceSummary || ''}
      showMoreLabel={isExpanded ? 'Less' : 'show more'}
      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => handleShowMoreBio(e)}
    />
  );
};

export default CaregiverBio;
